
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/properties/favourite",
      function () {
        return require("private-next-pages/properties/favourite.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/properties/favourite"])
      });
    }
  